import { computed, ref } from 'vue'

import { useTwBenchmarkTagsStore } from '../store/useTwBenchmarkTagsStore'

/**
 * タグ管理のためのカスタムフック。
 */
export function useTagManagement() {
  const tagsStore = useTwBenchmarkTagsStore()

  const tags = computed(() => tagsStore.tags)
  const pagedTags = computed(() => tagsStore.pagedTags)
  const totalCount = computed(() => tagsStore.totalCount)
  const currentPage = computed(() => tagsStore.currentPage)
  const pageSize = computed(() => tagsStore.pageSize)

  const confirmingTagId = ref<number | null>(null)

  const fetch = async (page?: number, size?: number): Promise<void> => {
    await tagsStore.fetchPagedTags(page, size)
  }

  const create = async (name: string): Promise<boolean> => {
    return tagsStore.createTag(name)
  }

  const rename = async (tagId: number, name: string): Promise<boolean> => {
    return tagsStore.renameTag(tagId, name)
  }

  const remove = async (tagId: number): Promise<number | null> => {
    return tagsStore.deleteTag(tagId)
  }

  const askDelete = (tagId: number): void => {
    confirmingTagId.value = tagId
  }

  const cancelDelete = (): void => {
    confirmingTagId.value = null
  }

  const confirmDelete = async (): Promise<number | null> => {
    const tagId = confirmingTagId.value
    if (tagId === null) return null

    const releasedCount = await tagsStore.deleteTag(tagId)
    confirmingTagId.value = null

    return releasedCount
  }

  return {
    tags,
    pagedTags,
    totalCount,
    currentPage,
    pageSize,
    confirmingTagId,
    fetch,
    create,
    rename,
    remove,
    askDelete,
    cancelDelete,
    confirmDelete
  }
}
